/* eslint-disable @typescript-eslint/no-explicit-any */
import { message, Modal } from 'antd';
import React, { useState } from 'react';
import fa from 'locales/fa.json';
import { CourseType, EventType, TermType } from 'types/course.type';
import request from 'services/request';
import { DirectPayUrl } from 'services/routes';
import { useDispatch } from 'react-redux';
import { getUserAction } from 'store/account/account.action';
import { SButton } from './style';
import { useRouter } from 'next/router';
import { getChapterAction } from 'store/course/course.action';
import Cookies from 'js-cookie';

type ModalType = {
  isVisible: boolean;
  type: string;
  setIsVisible: (status) => void;
  data:
    | CourseType
    | EventType
    | TermType
    | { price: number; registered: boolean; id: string; title: string };
};

const FreeModal: React.FC<ModalType> = ({ isVisible, setIsVisible, data, type }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const router = useRouter();
  const { courseId } = router.query;
  const handleRegister = async (): Promise<void> => {
    const refId = Cookies.get('taalei-ref');

    setLoading(true);
    const res: any = await request.post(DirectPayUrl(data.id, type), {
      useWallet: 0,
      code: '',
      refId,
    });
    setLoading(false);
    setIsVisible('');
    if (res.ok) {
      message.success(res.data.message);
      dispatch(getUserAction()); // we need to get new user with this new course on it's workshop
      courseId && dispatch(getChapterAction(courseId)); // if user register on lesson page
    }
  };
  return (
    <Modal
      title={null}
      footer={null}
      width={600}
      destroyOnClose
      visible={isVisible}
      onCancel={(): void => setIsVisible('')}
    >
      <div className="center flex-col ">
        <div className="font-bold text-[24px] border-b border-b-gray-1 w-full text-center pb-[15px]">
          {data?.title}
        </div>

        <div className="flex w-full justify-center">
          <SButton type="primary" loading={loading} onClick={handleRegister}>
            {fa.global.register} <span className="ml-[8px]">{fa.global.free}</span>
          </SButton>
        </div>
      </div>
    </Modal>
  );
};

export default FreeModal;
